import { motion } from "framer-motion";

export function LiveBadge({ label = "Live" }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-[#0B6BCB] font-body" data-testid="live-indicator">
      <motion.span
        className="w-2 h-2 rounded-full bg-[#0B6BCB]"
        animate={{ opacity: [1, 0.25, 1], scale: [1, 0.7, 1] }}
        transition={{ repeat: Infinity, duration: 1.6, ease: "easeInOut" }}
      />
      {label}
    </span>
  );
}
